<template>
  <div class="ace-feed-step-3 ace-content">
    <Header :images="dietType.images" :title="`${dietType.title} Diets`" />
    <h2 class="ace-feed-step-3__title">
      Comparing your diet against a low carbon benchmark
    </h2>
    <div class="ace-feed-step-3__comparison">
      <DietTable
        editable
        :diet-title="dietTitle"
        :diet="mappedDiet(diet, ingredients)"
        :result-value="carbonFootprint(mappedDiet(diet, ingredients))"
        result-unit="kg CO2-eq / kg DM"
        result-title="Estimated Carbon Footprint"
      />
      <DietTable
        :diet-title="exampleDiet.name"
        :diet="exampleDiet.diet"
        :result-value="carbonFootprint(exampleDiet.diet)"
        result-unit="kg CO2-eq / kg DM"
        result-title="Estimated Carbon Footprint"
      />
    </div>
    <!-- <ButtonGroup class="ace-feed-step-3__actions">
      <Button
        variant="dark"
        icon="arrow"
        text="Download PDF"
        @click="downloadPDF"
      />
      <Button
        variant="dark"
        icon="arrow"
        text="Email me the results"
        @click="toggleModal"
      />
    </ButtonGroup> -->
    <SmartMilling class="ace-feed-step-3__cta" />
    <Modal
      class="ace-feed-step-3__modal"
      :visible="modalVisible"
      @close="toggleModal"
    >
      <Form
        ref="form"
        :customer="customer"
        @submit="emailPDF"
        @close="toggleModal"
      />
    </Modal>
  </div>
</template>

<script>
import axios from 'axios';

import carbonFootprint from './_carbonFootprint';
import mappedDiet from './_mappedDiet';

import exampleDiet from './_exampleDiet';

import DietTable from './DietTable.vue';

import Modal from '../Layout/Modal.vue';
import Header from '../Layout/Header.vue';
/*import ButtonGroup from '../Layout/ButtonGroup.vue';
import Button from '../Layout/Button.vue';*/

import Form from '../Shared/Form.vue';
import SmartMilling from '../Shared/SmartMilling.vue';

export default {
  components: {
    Header,
    // ButtonGroup,
    // Button,
    Modal,
    Form,
    DietTable,
    SmartMilling,
  },
  props: ['dietType', 'ingredients', 'dietTitle', 'diet'],
  data() {
    return {
      axios: axios.create({
        baseURL: 'https://adesco.ie/api',
        // baseURL: 'http://localhost:8000/api',
        timeout: 30000,
      }),
      customer: {
        fullName: '',
        businessName: '',
        businessEmail: '',
        country: 'Ireland',
        phone: '',
        gdprOptIn: false,
      },
      status: null,
      modalVisible: false,
      exampleDiet: exampleDiet[this.dietType.name],
    };
  },
  computed: {},
  // props: {},
  methods: {
    toggleModal() {
      this.modalVisible = !this.modalVisible;

      this.$refs.form.$children[0].reset();

      if (!this.modalVisible) {
        this.customer = {
          fullName: '',
          businessName: '',
          businessEmail: '',
          country: 'Ireland',
          phone: '',
          gdprOptIn: false,
        };
      }
    },
    downloadPDF() {
      // const self = this;
      // this.status = 'working';
      // this.axios.post(
      //   'grain-beans/v1/download',
      //   this.payload,
      //   {
      //     responseType: 'arraybuffer',
      //     headers: {
      //       Accept: 'application/pdf',
      //     },
      //   },
      // ).then((resp) => {
      //   const blob = new Blob([resp.data], { type: 'application/pdf' });
      //   const link = document.createElement('a');
      //   const date = format(new Date(), 'yyyyMMdd_HHmmss');
      //   link.href = window.URL.createObjectURL(blob);
      //   link.download = `adesco_${date}.pdf`;
      //   link.click();
      //   self.status = 'done';
      // }).catch((err) => {
      //   console.log(err);
      //   self.status = 'error';
      // });
    },
    emailPDF() {
      // const self = this;
      // this.status = 'working';
      // this.axios.post(
      //   'grain-beans/v1/email',
      //   this.payload,
      //   {
      //     responseType: 'arraybuffer',
      //     headers: {
      //       Accept: 'application/pdf',
      //     },
      //   },
      // ).then(() => {
      //   setTimeout(this.toggleModal, 5000);
      //   self.status = 'done';
      // }).catch((err) => {
      //   console.log(err);
      //   self.status = 'error';
      // });
    },
    carbonFootprint,
    mappedDiet,
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/mixins';

.ace-feed-step-3 {
  margin-left: auto;
  margin-right: auto;
  max-width: 1030px;
  @media screen and (min-width: 767px) {
    padding: 0 30px;
  }
  &__title {
    @include title;
  }
  &__comparison {
    margin-top: 55px;

    display: flex;

    align-items: flex-start;
    column-gap: 30px;
    table {
      flex: 1;
    }
  }
  &__actions {
    margin-top: 55px;
  }
  &__cta {
    margin-top: 65px;
  }
}
</style>
